import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { ArrowLeft, Download, Minimize2, Maximize2 } from "lucide-react";

const PDF_URL = "https://customer-assets.emergentagent.com/job_wellness-journey-231/artifacts/ausuzf4c_Building_the_Bridge_ALIGN_Praxis.pdf";

export default function BuildingBridgePreview() {
  const navigate = useNavigate();
  const [fullscreen, setFullscreen] = React.useState(false);

  return (
    <>
      <Helmet>
        <title>Building the Bridge — Preview | ALIGN&bull;</title>
        <meta name="description" content="Preview the full 59-page Building the Bridge reflection workbook from ALIGN Praxis." />
      </Helmet>

      <div className={`flex flex-col ${fullscreen ? "fixed inset-0 z-[9999]" : "min-h-screen"}`} style={{ backgroundColor: "#F7F5F0" }} data-testid="building-bridge-preview">
        {/* Header */}
        <header className="bg-white/80 backdrop-blur-xl border-b border-white/20 shrink-0 z-10">
          <div className="max-w-[1600px] mx-auto px-4 md:px-8 flex items-center justify-between h-14">
            <div className="flex items-center gap-3 min-w-0">
              <button onClick={() => navigate("/tools/building-the-bridge")} className="text-[#5C635A] hover:text-[#4A6741] transition-colors shrink-0" data-testid="preview-back-button">
                <ArrowLeft size={16} />
              </button>
              <div className="min-w-0">
                <p className="text-sm font-medium text-[#1A1C19] truncate">Building the Bridge</p>
                <p className="text-[10px] text-[#5C635A] font-light">59-page reflection workbook · Scroll to preview</p>
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <a
                href={PDF_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[10px] uppercase tracking-wider font-medium bg-[#4A6741] text-white hover:bg-[#2C4027] transition-colors"
                data-testid="preview-download-btn"
              >
                <Download size={12} />
                Download PDF
              </a>
              <button
                onClick={() => setFullscreen(!fullscreen)}
                className="w-8 h-8 rounded-lg bg-[#F7F5F0] hover:bg-[#4A6741]/10 flex items-center justify-center text-[#5C635A] hover:text-[#4A6741] transition-colors"
                data-testid="preview-fullscreen-toggle"
              >
                {fullscreen ? <Minimize2 size={14} /> : <Maximize2 size={14} />}
              </button>
            </div>
          </div>
        </header>

        {/* PDF Viewer */}
        <div className="flex-1">
          <iframe
            src={`${PDF_URL}#toolbar=1&navpanes=0&scrollbar=1`}
            title="Building the Bridge — Reflection Workbook"
            className="w-full h-full border-0"
            style={{ minHeight: "calc(100vh - 56px)" }}
            data-testid="pdf-viewer-iframe"
          />
        </div>
      </div>
    </>
  );
}
